// Each stage's decisive moment: the move, the reader's or the opponent's,
// judged a blunder or a miss that cost its mover the most in the stage, by
// the review's own judgements. The library's stage scores open the game
// there (the position before it), so the score's cause is one click away.
import { type FactExtractor, type ScannedGame } from '../extractor.ts';
import { type GameFacts, type Phase, type StageTurn } from '@chess/api-model';

export const stageTurns: FactExtractor = {
  id: 'stage-turns',
  extract(game: ScannedGame, facts: GameFacts): void {
    const turns: Partial<Record<Phase, StageTurn>> = {};
    const opponent = game.reader === 'white' ? 'black' : 'white';
    for (const phase of ['opening', 'middlegame', 'ending'] as const) {
      const { fromPly, toPly } = game.range(phase);
      let best: StageTurn | undefined;
      for (let ply = fromPly + 1; ply <= Math.min(toPly, game.moves.length); ply++) {
        const move = game.moves[ply - 1];
        const own = game.isReaders(ply);
        const kind = game.judge.kind(ply, move, own ? game.reader : opponent);
        if (!kind) continue;
        const delta = game.judge.judgement(ply, move)?.delta ?? 0;
        if (!best || delta > best.delta) best = { ply, san: move.san, side: own ? 'own' : 'opponent', kind, delta };
      }
      if (best) turns[phase] = best;
    }
    if (Object.keys(turns).length) facts.stageTurns = turns;
  },
};
